import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { Body1Strong, InfoLabel as FluentInfoLabel, makeStyles, mergeClasses } from "@fluentui/react-components";
import { useKeyState } from "../hooks/keyboardHooks";
const useInfoLabelStyles = makeStyles({
    infoPopup: {
        whiteSpace: "normal",
        wordBreak: "break-word",
    },
    labelSlot: {
        display: "flex",
        minWidth: 0,
    },
    labelText: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    copyable: {
        cursor: "pointer",
    },
});
/**
 * Renders a label with an optional popup containing more info
 * @param props
 * @returns
 */
export const InfoLabel = (props) => {
    InfoLabel.displayName = "InfoLabel";
    const classes = useInfoLabelStyles();
    const ctrlPressed = useKeyState("Control");
    const infoContent = props.info ? _jsx("div", { className: classes.infoPopup, children: props.info }) : undefined;
    const showCopyCursor = ctrlPressed && props.onContextMenu;
    // Handle Ctrl+click as context menu action
    const handleClick = useCallback((e) => {
        if (e.ctrlKey && props.onContextMenu) {
            props.onContextMenu(e);
        }
    }, [props.onContextMenu]);
    return infoContent ? (_jsx(FluentInfoLabel, { htmlFor: props.htmlFor, info: infoContent, className: mergeClasses(props.className, showCopyCursor ? classes.copyable : undefined), label: props.flexLabel ? { className: classes.labelSlot } : undefined, onContextMenu: props.onContextMenu, onClick: handleClick, children: _jsx(Body1Strong, { className: classes.labelText, children: props.label }) })) : (_jsx("div", { className: mergeClasses(props.className, showCopyCursor ? classes.copyable : undefined), onContextMenu: props.onContextMenu, onClick: handleClick, children: _jsx(Body1Strong, { className: classes.labelText, children: props.label }) }));
};
//# sourceMappingURL=infoLabel.js.map